import React, { useState } from "react";
import { Box, Chip, IconButton, Menu, MenuItem, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { MiniConatctAndFamilyList } from "./MiniUserAndFamilyList";
import { AddNewFamily } from "./AddNewFamily";

export const ConsultingSidebarContent: React.FC = () => {
  const [isAddingFamily, setIsAddingFamily] = useState<boolean>(false);
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const theme = useTheme();

  const openMenu = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchor(event.currentTarget);
  };

  const closeMenu = () => {
    setMenuAnchor(null);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100vh", // ✅ גובה מלא
        backgroundColor: theme.palette.background.paper,
        position: "relative",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          flexShrink: 0,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
          pt: 2,
        }}
      >
        <Box sx={{ display: "flex", gap: 1 }}>
          <Chip
            label="יעוץ ללקוח חדש"
            component={Link}
            to="/consulting/new"
            clickable
            color="secondary"
            sx={{ fontWeight: "bold" }}
          />

        </Box>
        <IconButton onClick={openMenu}>
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={closeMenu}
        >
          <MenuItem
            onClick={() => {
              setIsAddingFamily(true);
              closeMenu();
            }}
          >
            משפחה חדשה
          </MenuItem>
        </Menu>
      </Box>

      {/* Scrollable List Area */}
      <Box
        sx={{
          display: "flex",         // 🟢 חשוב
          flexDirection: "column", // 🟢 חשוב
          flex: 1,                 // ✅ תופס את שארית המקום
          height: "100vh",         // ✅ מוגבל לגובה המסך
          overflow: "hidden",      // ✅ מונע גלילה חיצונית
        }}
      >
        <MiniConatctAndFamilyList />
      </Box>

      {/* Overlay for AddNewFamily */}
      {isAddingFamily && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundColor: theme.palette.background.default,
            zIndex: 10,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <AddNewFamily onClose={() => setIsAddingFamily(false)} />
        </Box>
      )}
    </Box>
  );
};
